import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { ConnectivityService } from "@shared/services/connectivity/connectivity.service";
import { CustomToastService } from "@shared/services/custom-toast/custom-toast.service";

export const OnlineGuard: CanActivateFn = (): boolean | UrlTree => {
  if (inject(ConnectivityService).isConnected()) return true;

  inject(CustomToastService).show({ message: "connection.required", type: "warning" });
  const router: Router = inject(Router);
  return router.navigated ? false : router.parseUrl("/");
};
